import { YouVersionContentContributionAgreement } from '@/components/content/YouVersionContentContributionAgreement';
import PageMeta from '@/components/PageMeta';

export default function Page() {
  return (
    <>
      <PageMeta title='YouVersion Content Contribution Agreement' />
      <div className='p-6'>
        <YouVersionContentContributionAgreement />
      </div>
    </>
  );
}
